import React, { Component, useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "./../component/Header";
import Footer from "./../component/Footer";
import HeadingSkeleton from "./../component/HeadingSkeleton";
import CartStoreSkeleton from "./../component/CartStoreSkeleton";
import $ from "jquery";
import { API_BASE_URL, IMAGE_URL } from "../utils/app_url";
import { useAuth } from "../context/AuthContext";
import { useLanguage } from "../context/LanguageContext";
import { NotificationManager } from "react-notifications";

const productImg = require("./../assets/img/product1-min.png");
const deleteIcon = require("./../assets/img/delete-icon2.svg").default;
const plusIcon = require("./../assets/img/plus-icon.svg").default;
const minusIcon = require("./../assets/img/minus-icon.svg").default;

const Cart = () => {
  const { user, setCartCount } = useAuth();
  const { selectedLanguage, langJson } = useLanguage();
  const navigate = useNavigate();

  const [cartDetails, setCartDetails] = useState();
  const [loading, setLoading] = useState(true);
  const [updatingId, setUpdatingId] = useState(null);

  const handleIncrement = async (mainItem, mainIndex, subItem, subIndex) => {
    if (updatingId === subItem.id) return;

    const originalArray = JSON.parse(JSON.stringify(cartDetails));
    let tempArray = [...cartDetails];
    if (tempArray[mainIndex].products[subIndex].quantity > 0) {
      tempArray[mainIndex].products[subIndex].quantity = Number(tempArray[mainIndex].products[subIndex].quantity) + 1;
      tempArray[mainIndex].products[subIndex].amount =
        Number(tempArray[mainIndex].products[subIndex].amount) + Number(tempArray[mainIndex].products[subIndex].price);

      tempArray[mainIndex].total = Number(tempArray[mainIndex].total) + Number(Number(tempArray[mainIndex].products[subIndex].price));
      tempArray[mainIndex].sub_total = Number(tempArray[mainIndex].sub_total) + Number(Number(tempArray[mainIndex].products[subIndex].price));
    }
    setCartDetails(tempArray);
    setUpdatingId(subItem.id);
    const updatedQuantity = tempArray[mainIndex].products[subIndex].quantity;
    try {
      const response = await fetch(`${API_BASE_URL}cart/update/${subItem.id}`, {
        method: "PUT",
        body: JSON.stringify({
          quantity: updatedQuantity,
          lang: selectedLanguage,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.authorisation.token}`,
        },
      });
      const responseData = await response.json();
      if (responseData.res === true) {
        // Success - keep the UI update
      } else {
        // Error - revert the UI change and show error
        setCartDetails(originalArray);
        NotificationManager.error(responseData.msg || langJson?.somethingwentwronginserverpleasetryagain);
      }
    } catch (error) {
      setCartDetails(originalArray);
      NotificationManager.error(langJson?.somethingwentwronginserverpleasetryagain);
    } finally {
      setUpdatingId(null);
    }
  };

  const handleDecrement = async (mainItem, mainIndex, subItem, subIndex) => {
    if (updatingId === subItem.id) return;

    const originalArray = JSON.parse(JSON.stringify(cartDetails));
    let tempArray = [...cartDetails];
    if (Number(tempArray[mainIndex].products[subIndex].quantity) <= 1) {
      return;
    }

    if (tempArray[mainIndex].products[subIndex].quantity > 1) {
      tempArray[mainIndex].products[subIndex].quantity = Number(tempArray[mainIndex].products[subIndex].quantity) - 1;
      tempArray[mainIndex].products[subIndex].amount =
        Number(tempArray[mainIndex].products[subIndex].amount) - Number(tempArray[mainIndex].products[subIndex].price);

      tempArray[mainIndex].total = Number(tempArray[mainIndex].total) - Number(Number(tempArray[mainIndex].products[subIndex].price));
      tempArray[mainIndex].sub_total = Number(tempArray[mainIndex].sub_total) - Number(Number(tempArray[mainIndex].products[subIndex].price));
    }
    setCartDetails(tempArray);
    setUpdatingId(subItem.id);
    const updatedQuantity = tempArray[mainIndex].products[subIndex].quantity;
    try {
      const response = await fetch(`${API_BASE_URL}cart/update/${subItem.id}`, {
        method: "PUT",
        body: JSON.stringify({
          quantity: updatedQuantity,
          lang: selectedLanguage,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.authorisation.token}`,
        },
      });
      const responseData = await response.json();
      if (responseData.res === true) {
        // Success - keep the UI update
      } else {
        // Error - revert the UI change and show error
        setCartDetails(originalArray);
        NotificationManager.error(responseData.msg || langJson?.somethingwentwronginserverpleasetryagain);
      }
    } catch (error) {
      setCartDetails(originalArray);
      NotificationManager.error(langJson?.somethingwentwronginserverpleasetryagain);
    } finally {
      setUpdatingId(null);
    }
  };

  //   return (
  //     <div className="quantity-selector">
  //       <button onClick={handleDecrement}>-</button>
  //       <span>{quantity}</span>
  //       <button onClick={handleIncrement}>+</button>
  //     </div>
  //   );
  // };

  const fetchCart = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}frontend/cart`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.authorisation.token}`,
        },
      });
      const responseData = await response.json();
      if (responseData.res === true) {
        setCartDetails(responseData?.data);
      } else {
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const deleteCart = async (mainIndex, subIndex, cartId) => {
    let tempArray = [...cartDetails];
    tempArray[mainIndex].total = Number(tempArray[mainIndex].total) - Number(tempArray[mainIndex].products[subIndex]?.amount);
    tempArray[mainIndex].sub_total = Number(tempArray[mainIndex].sub_total) - Number(Number(tempArray[mainIndex].products[subIndex]?.amount));
    tempArray[mainIndex].products.splice(subIndex, 1);
    if (tempArray[mainIndex].products.length === 0) {
      tempArray.splice(mainIndex, 1);
    }
    setCartDetails(tempArray);
    setCartCount((prev) => prev - 1);

    try {
      const response = await fetch(`${API_BASE_URL}cart/remove/${cartId}`, {
        method: "POST",
        body: JSON.stringify({
          // CartId: cartId,
          lang: selectedLanguage,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.authorisation.token}`,
        },
      });
      const responseData = await response.json();
      if (responseData.res === true) {
      } else {
      }
    } catch (error) { }
  };

  const onPlaceOrder = (storeId) => {
    navigate("/address");
    sessionStorage.setItem("FFFStoreId", storeId);
  };

  useEffect(() => {
    if (user) {
      fetchCart();
      sessionStorage.removeItem("FFFShippingId");
      sessionStorage.removeItem("FFFStoreId");
    }
  }, [user]);

  return (
    <div>
      <Header />
      <style>{`body { background: #FFF; }`}</style>

      <div className="mainDiv">
        <div className="cartMain cartDivNew">

          {user && loading ? <HeadingSkeleton width="120px" height="34px" /> : <h2 class="storeTabHdn">{langJson?.cart}</h2>}

          {!user ? (
            <div className="cartDiv">
              <h6>{langJson?.noitemsfound}</h6>
            </div>
          ) : loading ? (
            Array.from({ length: 2 }).map((_, index) => <CartStoreSkeleton key={`cart-store-skeleton-${index}`} />)
          ) : cartDetails?.length > 0 ? (
            cartDetails?.map((item, index) => (
              <div className="cartDiv" key={index}>

                

                <div class="cartLoop">
                  <div className="cartEachLoop">
                    {item?.products.map((chItem, chIndex) => (
                      <ul className="cartTable" key={chIndex}>
                        <li>
                          <div className="imgCart">
                            <img src={IMAGE_URL + chItem?.product?.primary_image?.image} alt="" className="cartPrdt" />
                          </div>
                          <div className="cartDtls">
                            <h3>{chItem?.product?.title}</h3>
                            <h5>{langJson?.colour}: {chItem?.product?.color}</h5>
                            <h5>{langJson?.size}: {chItem?.size}</h5>
                            <div className="deleteImg" onClick={() => deleteCart(index, chIndex, chItem.id)} style={{ cursor: "pointer" }}>
                              <img src={deleteIcon} alt="" />
                            </div>
                            <div className="cartQuantity">
                              <div className="quantity-selector">
                                <button
                                  disabled={Number(chItem?.quantity) <= 1 || updatingId === chItem.id}
                                  onClick={() => handleDecrement(item, index, chItem, chIndex)}
                                  style={{ cursor: Number(chItem?.quantity) <= 1 || updatingId === chItem.id ? "not-allowed" : "pointer" }}
                                >
                                  -
                                </button>
                                <span>{Number(chItem?.quantity)}</span>
                                <button disabled={updatingId === chItem.id} onClick={() => handleIncrement(item, index, chItem, chIndex)} style={{ cursor: updatingId === chItem.id ? "not-allowed" : "pointer" }}>+</button>
                              </div>
                              <div className="cartPriceTotal">
                                <h4>{langJson?.price}: ₹ {chItem?.price}</h4>
                                <h4>{langJson?.total}: ₹ {(Number(chItem?.price) * Number(chItem?.quantity)).toFixed(2)}</h4>
                              </div>
                            </div>
                          </div>
                        </li>

                        {/* <li onClick={() => deleteCart(index, chIndex, chItem.id)} style={{ cursor: "pointer" }}>
                      <img src={deleteIcon} alt="" />
                    </li> */}
                      </ul>
                    ))}
                  </div>

                  <ul className="totalDiv">
                    <li className="PriceTtl">
                      <label>{langJson?.totalquantity}:</label>
                      <span>{item?.products?.reduce((sum, prod) => sum + Number(prod?.quantity), 0)} {langJson?.pcs}</span>
                    </li>
                    <li className="PriceTtl">
                      <label>{langJson?.subtotal}:</label>
                      <span>₹ {item?.sub_total ? item?.sub_total.toFixed(2) : 0}</span>
                    </li>
                    <li className="PriceTtl">
                      <label>
                        {langJson?.tax} ({item?.tax ? item?.tax : "0"}%) :
                      </label>
                      <span>₹ {item?.tax_total ? Number(item?.tax_total).toFixed(2) : 0}</span>
                    </li>
                    <li className="PriceTtl prcMain">
                      <label>{langJson?.total}:</label>
                      <span>₹ {(parseFloat(item?.sub_total) + parseFloat(item?.tax_total)).toFixed(2)}</span>
                      {/* <span>${item?.total ? parseInt(item?.sub_total) + parseInt(item?.tax_total) : 0}</span> */}
                    </li>
                    {/* <li>
                    {item?.store?.payment_terms ? (
                      <p>
                        {langJson?.paymentterms}*: {item?.store?.payment_terms}
                      </p>
                    ) : null}
                    {item?.store?.shipping_terms ? (
                      <p>
                        {langJson?.shippingterms}*: {item?.store?.shipping_terms}
                      </p>
                    ) : null}
                  </li> */}
                    <li>
                      <div className="cartDivBtns">
                        <button className="button orderBtn" onClick={() => onPlaceOrder(item?.store_id)}>
                          {langJson?.placeorder}
                        </button>
                        <Link to='/shop/' className="button addBtn">
                          {langJson?.addshopping}
                        </Link>
                      </div>
                    </li>
                  </ul>
                </div>

                <div className="paymentTrms">
                  {item?.store?.payment_terms ? (
                    <p>
                      {langJson?.paymentterms}*: {item?.store?.payment_terms}
                    </p>
                  ) : null}
                  {item?.store?.shipping_terms ? (
                    <p>
                      {langJson?.shippingterms}*: {item?.store?.shipping_terms}
                    </p>
                  ) : null}
                </div>



              </div>
            ))
          ) : !loading ? (
            <>
              <div className="cartDiv">
                <h6>{langJson?.noitemsfound}</h6>
              </div>
            </>
          ) : null}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Cart;
